import store from '@/store/index.js'
import { makeRequest } from '@/libs/RequestModule'
import { getFlagName } from '@/libs/Util.js'

const getCardRechargeDetails = async function () {
    const response = (await makeRequest('getCardRechargeDetails'))?.data
    // const cardRechargeDetails = response?.data
    // store.dispatch('setCardRechargeList', cardRechargeDetails)
    return response
}

const doCardRecharge = async function (totalValue, flag, cardExpiration, cardNumber, cardCVV, cardHolder, rechargeValues, mode) {
    flag = getFlagName(flag)
    const response = await makeRequest('doCardRecharge', { totalValue, flag, cardExpiration, cardNumber, cardCVV, cardHolder, rechargeValues, mode })
    return response
}

const doCardTokenRecharge = async function (totalValue, flag, cardExpiration, cardToken, cardCVV, cardHolder, rechargeValues, mode, tipoRece = null, finalNumbers) {
    flag = getFlagName(flag)
    const response = await makeRequest('doCardRecharge', { totalValue, flag, cardExpiration, cardToken, cardCVV, cardHolder, rechargeValues, mode, tipoRece, finalNumbers })
    return response
}

const doCardInvoicePayment = async function (invoiceTotalValue, flag, cardExpiration, cardNumber, cardCVV, cardHolder, mode, idBoletos) {
    flag = getFlagName(flag)
    const response = await makeRequest('doCardInvoicePayment', { totalValue: invoiceTotalValue, flag, cardExpiration, cardNumber, cardCVV, cardHolder, mode, idBoletos })
    return response
}

const doCardTokenInvoicePayment = async function (invoiceTotalValue, flag, cardExpiration, cardToken, cardCVV, cardHolder, mode, finalNumbers, idBoletos) {
    flag = getFlagName(flag)
    const response = await makeRequest('doCardInvoicePayment', { totalValue: invoiceTotalValue, flag, cardExpiration, cardToken, cardCVV, cardHolder, mode, finalNumbers, idBoletos })
    return response
}

const updateSonsAfterRecharge = async function () {
    const response = (await makeRequest('getfilhos'))?.data
    store.dispatch('setDependents', response)
}

export {
    getCardRechargeDetails,
    doCardRecharge,
    doCardTokenRecharge,
    updateSonsAfterRecharge,
    doCardInvoicePayment,
    doCardTokenInvoicePayment
}
